import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    categoryName: yup.string().required("Category name is required"),
  })
  .required("All fields are required");

const Validation = ({ categoryName }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: { categoryName },
  });
};

export default Validation;
